// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__ufj9x","cardImage":"styles_cardImage__uZgq4","cardText":"styles_cardText__R4K+8"};